import { TextFieldModel } from '@types'

import { Input } from '@components/Input'
import { TextArea } from '@components/TextArea'

import { FormFieldCard, FormFieldCardProps } from '../FormFieldCard'

import { Container } from './FormFieldText.styled'
import { useTranslation } from 'react-i18next'

type ActionsProps = Pick<
  FormFieldCardProps,
  'canDown' | 'canUp' | 'onDelete' | 'onDuplicate' | 'onUp' | 'onDown' | 'hideRequired'
>

type FormFieldContentProps = {
  field: TextFieldModel
  onChange: (value: Partial<TextFieldModel>) => void
}

type FormFieldTextProps = FormFieldContentProps & ActionsProps

export const FormFieldText: React.FC<FormFieldTextProps> = ({
  field,
  onChange,
  ...actionsProps
}: FormFieldTextProps) => {
  return (
    <FormFieldCard
      name={field.label}
      required={field.required}
      onChangeRequired={(value) => {
        onChange({ required: value })
      }}
      {...actionsProps}
    >
      <FormFieldTextContent field={field} onChange={onChange} />
    </FormFieldCard>
  )
}

export const FormFieldTextContent: React.FC<FormFieldContentProps> = ({ field, onChange }: FormFieldContentProps) => {
  const { t } = useTranslation()

  return (
    <Container>
      <Input
        type="text"
        required
        label={t('modules_project-form-models_components_FormFieldText_question_label')}
        value={field.label}
        onChange={(value) => onChange({ label: value })}
      />

      <TextArea required disabled label={t('modules_project-form-models_components_FormFieldText_label')} value="" />
    </Container>
  )
}
